import { call, customEvent } from "goi_common";
import { GOI_PHONE } from "@/constants/contact";
import { PhoneIcon } from "@/components/PhoneIcon";

/**
 * 공통 견적 LP 히어로
 * - 장례식장별 정보 없이 일반 안내
 * - 클래스는 quote-landing.css의 .lp-parlor 그대로 재사용
 */
export const CommonQuoteHero = () => {
  const handlePhoneClick = () => {
    customEvent({
      newGtm: {
        path: "funeral_cost_ad",
        trigger_and_target: "btn_phone_hero",
      },
    });
    call(GOI_PHONE);
  };

  return (
    <section className="lp-parlor">
      <div className="lp-hero-row">
        <h1>
          장례 비용,
          <br />
          얼마인지 미리 알아보세요
        </h1>
        <button
          type="button"
          onClick={handlePhoneClick}
          className="lp-hero-phone"
          aria-label={`24시간 전화 ${GOI_PHONE}`}
        >
          <PhoneIcon size={14} />
          <span>24시간 전화</span>
        </button>
      </div>
    </section>
  );
};
